import { OverlayService } from '~/lib/services/overlay-service'
import { defineServiceComposable } from '~/composables/service-container'

export const useOverlayService = defineServiceComposable(
  'overlay',
  () =>
    new OverlayService({
      scrollLockService: useScrollLockService(),
    }),
)
